import { TOGGLE_LOADER, SET_TIMELINE_DATES } from '../../constants/appTypes';
import { IDateRangeObject } from '../../types/timeline';

export const toggleLoader = (active: boolean) => {
  return {
    type: TOGGLE_LOADER,
    active,
  };
};

export const setTimelineDates = (dates: IDateRangeObject) => {
  return {
    type: SET_TIMELINE_DATES,
    dates,
  };
};
